<template>
  <div class="page noselect setupKiosk">
    <!--        <div class="absBack">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--        <h1 class="myTitle tablet">Impressum</h1>-->


    <div class="text-center mt-7">
      <!--      <h4 class="text-center">Filiale: </h4>-->
      <h2 class="text-center">Terminal-ID: {{ $store.getters.table }}</h2>
    </div>


    <v-container grid-list-md v-if="viewMode===1">
      <div class="text-center mt-7">
        <h2>Kassierer Funktionen</h2>
        <div class="mt-4">
          <v-btn color="btn-df"
                 @click="clickBestellungen"
          >
            Letzte Bestellungen
          </v-btn>
        </div>

        <div class="pa-0" v-if="$store.getters.isKiosk && $store.getters.isAndroidKiosk">

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <!--              <KioskInputWrapper v-model="androidKioskUrl">-->

              <div class="d-flex align-center">
                <v-text-field
                    v-model.number="refundAmount"
                    hide-details
                    label="Betrag"
                    type="number"
                    outlined
                    :rules="[numberRule]"
                    @input="validateInput"
                >
                </v-text-field>

                <v-btn
                    depressed
                    color="error"
                    class="ml-3 mr-3 mb-3"
                    min-width="44"
                    height="44"
                    :disabled="refundAmount <= 0"
                    @click="refundAmount--; validateInput()"
                >
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
                <v-btn
                    depressed
                    color="success"
                    class="ml-3 mb-3"
                    min-width="44"
                    height="44"
                    @click="refundAmount++; validateInput()"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>

              <!--              </KioskInputWrapper>-->

              <v-btn class="btn-mini"
                     @click="clickErstatteBetrag"
              >
                Jetzt Erstatten
              </v-btn>
            </div>
          </div>

        </div>

        <div class="mt-4">
          <v-btn color="btn-df"
                 @click="viewMode=2"
          >
            Öffne Setup Details
          </v-btn>
        </div>

        <div class="mt-4">
          <v-btn color="btn-mini"
                 @click="onCLickReload"
          >
            App Neu Laden
          </v-btn>
        </div>

        <template v-if="$store.getters.isAndroidKiosk">
          <div class="mt-4">
            <v-btn color="btn-mini"
                   @click="exitApp"
            >
              Exit App
            </v-btn>
          </div>

        </template>
      </div>
    </v-container>

    <v-container fluid grid-list-md v-if="viewMode===2">

      <div class="text-center mt-7">
        <h2>Setup Details</h2>

        <div class="spacer-15"></div>
        <div>
          isKiosk: {{ $store.getters.isKiosk }}
        </div>
        <div>
          table: {{ $store.getters.table }}
        </div>
        <div>
          simulatePayment: {{ $store.getters.simulatePayment }}
        </div>

        <div class="mt-4">
          <v-btn color="btn-mini"
                 @click="clickBestellungen"
          >
            Letzte Bestellungen
          </v-btn>
        </div>

        <div class="superCenter">
          <div class="d-inline-block myBox">
            <!--              <KioskInputWrapper v-model="kioskFontSize">-->
            <div class="d-flex align-center">
              <v-text-field
                  v-model.number="kioskFontSize"
                  hide-details
                  label="Textgröße"
                  type="number"
                  outlined
                  :rules="[numberRule]"
                  @input="validateInputFontSize"
              >
              </v-text-field>

              <v-btn
                  depressed
                  color="error"
                  class="ml-3 mr-3 mb-3"
                  min-width="44"
                  height="44"
                  :disabled="kioskFontSize <= 0"
                  @click="kioskFontSize--; validateInputFontSize()"
              >
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              <v-btn
                  depressed
                  color="success"
                  class="ml-3 mb-3"
                  min-width="44"
                  height="44"
                  @click="kioskFontSize++; validateInputFontSize()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>

            <!--              </KioskInputWrapper>-->
            <v-btn class="btn-mini"
                   @click="setKioskFontSize"
            >
              Set
            </v-btn>
            <v-btn class="btn-mini ml-4"
                   @click="getKioskFontSize"
            >
              Get
            </v-btn>
          </div>
        </div>

        <!--        <div class="pa-0">-->
        <div class="pa-0" v-if="$store.getters.isKiosk && $store.getters.isAndroidKiosk">

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <!--              <KioskInputWrapper v-model="androidKioskUrl">-->

              <div class="d-flex align-center">
                <v-text-field
                    v-model.number="refundAmount"
                    hide-details
                    label="Betrag"
                    type="number"
                    outlined
                    :rules="[numberRule]"
                    @input="validateInput"
                >
                </v-text-field>

                <v-btn
                    depressed
                    color="error"
                    class="ml-3 mr-3 mb-3"
                    min-width="44"
                    height="44"
                    :disabled="refundAmount <= 0"
                    @click="refundAmount--; validateInput()"
                >
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
                <v-btn
                    depressed
                    color="success"
                    class="ml-3 mb-3"
                    min-width="44"
                    height="44"
                    @click="refundAmount++; validateInput()"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>

              <!--              </KioskInputWrapper>-->

              <v-btn class="btn-mini"
                     @click="clickErstatteBetrag"
              >
                Jetzt Erstatten
              </v-btn>
            </div>
          </div>


          <div class="superCenter">
            <div class="d-inline-block myBox">

              <!--              inputmode="none"-->
              <!--              :input-props="{ inputmode: 'none' }"-->

              <KioskInputWrapper v-model="androidKioskUrl">
                <v-text-field
                    v-model="androidKioskUrl"
                    label="Android Kiosk URL"
                    outlined hide-details
                ></v-text-field>
              </KioskInputWrapper>
              <div class="pt-2 pb-2" style="font-size: 0.8em; max-width: 800px">
                Geladene URL: {{ loadedUrl }}
              </div>

              <v-btn class="btn-mini"
                     @click="setAndroidKioskUrl"
              >
                Set
              </v-btn>
              <v-btn class="btn-mini ml-4"
                     @click="getAndroidKioskUrl"
              >
                Get
              </v-btn>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <h3>Ausgabeparameter</h3>
              <table class="table-collapse configTable">
                <tr>
                  <td>
                    <div>App Build Time</div>
                    <v-textarea hide-details class="outputTextarea"
                                v-model="androidBuildTime"
                                outlined
                                rows="3"
                                auto-grow
                                font-family="monospace"
                                persistent-hint
                    ></v-textarea>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getAndroidBuildTime"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div>Bluetooth Devices</div>
                    <v-textarea hide-details class="outputTextarea"
                                v-model="bluetoothDevices"
                                outlined
                                rows="3"
                                auto-grow
                                font-family="monospace"
                                persistent-hint
                    ></v-textarea>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getAndroidBluetoothDevices"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>
                    <v-textarea hide-details
                                v-model="printerLog"
                                label="Printer Log"
                                outlined
                                rows="8"
                                auto-grow
                                font-family="monospace"
                                persistent-hint
                    ></v-textarea>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getPrinterLog"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div>Simulated Bon Print Visual 0</div>
                    <div v-if="$store.getters.bonImagePreviewUrl0.length>100">
                      <img :src="$store.getters.bonImagePreviewUrl0" alt="Bon Vorschau"
                           style="border: 1px dashed #ccc; max-width: 100%;"/>
                    </div>
                    <!--                <div style="line-break: anywhere">bonImagePreviewUrl: {{$store.getters.bonImagePreviewUrl}}</div>-->
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getAndroidBonImageBase64(0)"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div>Simulated Bon Print Visual 1</div>
                    <div v-if="$store.getters.bonImagePreviewUrl1.length>100">
                      <img :src="$store.getters.bonImagePreviewUrl1" alt="Bon Vorschau"
                           style="border: 1px dashed #ccc; max-width: 100%;"/>
                    </div>
                    <!--                <div style="line-break: anywhere">bonImagePreviewUrl: {{$store.getters.bonImagePreviewUrl}}</div>-->
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getAndroidBonImageBase64(1)"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div>Simulated Bon Print Visual 2</div>
                    <div v-if="$store.getters.bonImagePreviewUrl2.length>100">
                      <img :src="$store.getters.bonImagePreviewUrl2" alt="Bon Vorschau"
                           style="border: 1px dashed #ccc; max-width: 100%;"/>
                    </div>
                    <!--                <div style="line-break: anywhere">bonImagePreviewUrl: {{$store.getters.bonImagePreviewUrl}}</div>-->
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getAndroidBonImageBase64(2)"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div>Softpos Verkaufstellen</div>
                    <v-textarea hide-details class="outputTextarea"
                                v-model="allPaymentStores"
                                outlined
                                rows="3"
                                auto-grow
                                font-family="monospace"
                                persistent-hint
                    ></v-textarea>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getAndroidAllPaymentStores"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div>Softpos Terminal State</div>
                    <v-text-field
                        inputmode="none"
                        :input-props="{ inputmode: 'none' }"
                        v-model="softposTerminalState"
                        outlined hide-details
                    ></v-text-field>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getSoftposTerminalState"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div>Aktiver Store im Terminal</div>
                    <div v-if="storePicked.storeId">Name: {{ storePicked.storeName }},<br>
                      StoreID: {{ storePicked.storeId }},<br>
                      SoftpayAppId: {{ storePicked.softpayAppId }}
                    </div>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getStorePicked"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

              </table>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <v-container>
                <KioskInputWrapper v-model="androidJsonAppConfig">
                  <v-textarea hide-details
                              v-model="androidJsonAppConfig"
                              label="JSON Application Config"
                              outlined
                              rows="19"
                              auto-grow
                              clearable
                              font-family="monospace"
                              hint="Hier kannst du deine Konfiguration bearbeiten"
                              persistent-hint
                  ></v-textarea>
                </KioskInputWrapper>
              </v-container>
              <v-btn class="btn-mini"
                     @click="setAndroidJsonAppConfig"
              >
                Set
              </v-btn>
              <v-btn class="btn-mini ml-4"
                     @click="getAndroidJsonAppConfig"
              >
                Get
              </v-btn>
            </div>
          </div>

        </div>

        <div v-if="$store.getters.isKiosk && !$store.getters.isAndroidKiosk">
          <div class="spacer-15"></div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <h3>Ausgabeparameter</h3>
              <table class="table-collapse configTable">
                <tr>
                  <td>
                    <div>Bluetooth Devices</div>
                    <v-textarea hide-details class="outputTextarea"
                                readonly
                                v-model="bluetoothDevices"
                                outlined
                                rows="3"
                                auto-grow
                                font-family="monospace"
                                persistent-hint
                    ></v-textarea>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getWindowsBluetoothDevices"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>
                    <v-textarea hide-details
                                v-model="printerLog"
                                label="Printer Log"
                                outlined
                                rows="8"
                                auto-grow
                                font-family="monospace"
                                persistent-hint
                    ></v-textarea>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getPrinterLog"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

              </table>
            </div>
          </div>


          <div class="superCenter">
            <div class="d-inline-block myBox">
              <h3>Output Params:</h3>
              <div>Last Update: {{ lastUpdateOutputParams }}</div>
              <div style="white-space: pre">{{ paramsString }}</div>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <div class="flex">
                <h3>All Params:</h3>
                <v-spacer></v-spacer>
                <v-btn class="btn-mini"
                       @click="readAllParams"
                >Refresh
                </v-btn>
              </div>
              <div style="white-space: pre">{{ allParamsString }}</div>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <!--              <v-text-field-->
              <!--                v-model="terminalIpAddress"-->
              <!--                label="Terminal IP Address"-->
              <!--                outlined hide-details-->
              <!--              ></v-text-field>-->

              <v-text-field
                  v-model="doubleValue"
                  label="Betrag (inkl. Trinkgeld)"
                  type="number"
                  step="0.01"
                  :rules="[validateDouble]"
                  outlined hide-details
              ></v-text-field>

              <v-text-field
                  v-model="doubleTrinkgeld"
                  label="Trinkgeld (optional)"
                  type="number"
                  step="0.01"
                  :rules="[validateDouble]"
                  outlined hide-details
              ></v-text-field>

              <v-btn color="btn-df"
                     @click="triggerTerminalPayment"
              >
                Trigger Payment
              </v-btn>
            </div>
          </div>

          <v-btn color="btn-df"
                 @click="checkTerminalServiceActive"
          >
            Check Terminal Service active
          </v-btn>
          <div class="spacer-15"></div>
          <v-btn color="btn-df"
                 @click="getCurrentTerminalIp"
          >
            Get current terminal IP
          </v-btn>
          <div class="spacer-15"></div>
          <v-btn color="btn-df"
                 @click="clickTriggerDiagnose"
          >
            Trigger Diagnose
          </v-btn>

          <div class="spacer-15"></div>
          <v-btn color="btn-df"
                 @click="finishSetup"
          >
            Finish Setup and Open Start Page
          </v-btn>
        </div> <!--          eof kiosk=true-->

        <div class="spacer-20"></div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="clickDebugParams"
          >
            Öffne Konfigurationsparameter
          </v-btn>
        </div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="clickSetupShowHide"
          >
            Setup Button aus/einblenden
          </v-btn>
        </div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="releaseTerminal"
          >
            Release Terminal
          </v-btn>
        </div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="dummyPrint"
          >
            Print Dummy Abholbon
          </v-btn>
        </div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="dummyPrintKitchen"
          >
            Print Dummy Küchenbon
          </v-btn>
        </div>


        <template v-if="isDev">
          <div class="spacer-40"></div>
          <v-btn color="btn-mini"
                 @click="exitKiosk"
          >
            Exit Kiosk Mode
          </v-btn>
        </template>

      </div>


    </v-container>


    <!--    <DummyZvtDialog-->
    <!--        :total="22"-->
    <!--        :dialog="showDummyDialog"-->
    <!--        ></DummyZvtDialog>-->

  </div>
</template>

<script>

import store from "../store/store";
import {ebus} from "../vendor/ebus";
import {clearEvents, clearTheInterval, doReload, isEmptyObject} from "../vendor/util";
// import DummyZvtDialog from "../dialogs/DummyZvtDialog.vue";
import ZvtDialog from "../dialogs/ZvtDialog.vue";
import KioskInputWrapper from "./KioskInputWrapper.vue";
import {setGlobalKeyValue} from "../util/globalState";
import {isDev} from "../vendor/qconstants";

export default {
  components: {KioskInputWrapper, ZvtDialog},
  data: () => ({
    iv1: null,
    viewMode: 1,
    isDev: isDev,
    doubleValue: null,
    doubleTrinkgeld: null,
    params: null,
    allParams: null,
    lastUpdateOutputParams: 0,

    refundAmount: 0,
    numberRule: v => {
      if (!v && v !== 0) return 'Eingabe erforderlich';
      return /^-?\d*(\.\d+)?$/.test(v) || 'Ungültiges Zahlenformat (Punkt nutzen)';
    },

    androidKioskUrl: '',
    loadedUrl: window.location.href,
    kioskFontSize: 22,
    // softposStoreName: '',
    androidJsonAppConfig: '',
    bluetoothDevices: '',
    androidBuildTime: '',
    allPaymentStores: '',
    printerLog: '',

    showDummyDialog: false,
  }),

  created() {
    ebus.$on('cb-postToWindowskiosk', (resp) => {
      console.log('receive callback from cb-postToWindowskiosk');
      if (resp && !isEmptyObject(resp)) {
        const responseAction = '' + resp.action;
        delete resp.action;

        if (responseAction === 'triggerPosTerminal') {
          ebus.$emit('showInfo', {
            title: 'trigger response: ' + JSON.stringify(resp, null, 2),
            // text: 'Vielen Dank!'
          });
        } else if (responseAction === 'readStatusFromTerminal') {
          this.handleZvtStatusResponse(resp);
        } else if (responseAction === 'readErgebnisFromTerminal') {
          this.params = resp;
        } else if (responseAction === 'readAllParams') {
          this.allParams = resp;
        } else if (responseAction === 'checkTerminalServiceActive') {
          if (!(resp.ok && resp.configSetupCompleted)) {
            ebus.$emit('showInfo', {
              title: 'WARNING: The device setup is incomplete. Please contact the administrator',
              text: 'Setup check response: ' + JSON.stringify(resp),
            });
          } else {
            ebus.$emit('showInfo', {
              title: 'Setup check response: ' + JSON.stringify(resp),
              // text: 'Vielen Dank!'
            });
          }
        } else if (responseAction === 'getCurrentTerminalIp') {
          ebus.$emit('showInfo', {
            title: 'response: ' + JSON.stringify(resp, null, 2),
            // text: 'Vielen Dank!'
          });
        } else if (responseAction === 'triggerDiagnose') {
          ebus.$emit('showInfo', {
            title: 'diagnose response: ' + JSON.stringify(resp, null, 2),
            // text: 'Vielen Dank!'
          });
        } else if (responseAction === 'dummyPrint') {
          ebus.$emit('showInfo', {
            title: 'dummyPrint response: ' + JSON.stringify(resp, null, 2),
            // text: 'Vielen Dank!'
          });
        } else if (responseAction === 'getPrinterLog') {
          if (resp?.printerLog?.length) {
            store.commit('printerLog', '' + resp.printerLog);
          }
        } else if (responseAction === 'getBluetoothDevices') {
          if (resp?.devices?.length) {
            store.commit('bluetoothDevices', '' + JSON.stringify(resp.devices, null, 2));
          } else {
            store.commit('bluetoothDevices', '[]');
          }
        }
      }
    });

  },

  mounted() {
    if (store.getters.isKiosk && !store.getters.isAndroidKiosk) {
      this.initIv();
    }
    if (store.getters.isKiosk && store.getters.isAndroidKiosk) {
      this.getKioskFontSize();
      this.getAndroidKioskUrl();
      this.getAndroidJsonAppConfig();
    }
    store.commit('showLoading', false);
  },

  destroyed() {
    clearEvents([
      'cb-postToWindowskiosk',
    ]);
    clearInterval(this.iv1);
  },

  computed: {
    storePicked() {
      return store.getters.storePicked;
    },

    softposTerminalState() {
      return store.getters.softposTerminalState;
    },

    paramsString() {
      if (!this.params) {
        return "loading...";
      }
      return JSON.stringify(this.params, null, 2);
    },

    allParamsString() {
      if (!this.allParams) {
        return "";
      }
      return JSON.stringify(this.allParams, null, 2);
    },

  },

  methods: {
    onCLickReload() {
      if (store.getters.isAndroidKiosk) {
        ebus.$emit('restartAndroidApp');
      } else {
        doReload('SetupKiosk');
      }
    },

    validateInput(value) {
      // sicherstellen, dass im Model immer eine Zahl landet:
      this.refundAmount = value.replace(/[^0-9.-]/g, '');
    },

    validateInputFontSize(value) {
      // sicherstellen, dass im Model immer eine Zahl landet:
      this.kioskFontSize = value.replace(/[^0-9.-]/g, '');
    },

    clickErstatteBetrag() {
      try {
        const refundAmountValue = parseFloat(this.refundAmount);
        if (refundAmountValue) {
          console.log('trigger softposRefundAmount for amount ' + refundAmountValue);
          ebus.$emit('softposRefundAmount', {
            amount: refundAmountValue
          });
        }
      } catch (e) {
      }
    },

    setKioskFontSize() {
      try {
        const root = document.documentElement;
        const size = parseFloat(this.kioskFontSize);
        // Setzen der Property
        const sizePx = '' + size + 'px';
        document.body.style.fontSize = sizePx
        document.documentElement.style.fontSize = sizePx
        // root.style.setProperty('--kiosk-font-size', sizeRem);
        this.$ls.set('kioskFontSize', size);
      } catch (e) {
        ebus.$emit('toast', 'Fehler beim Speichern der Textgröße: ' + e.message);
      }

      // Beispielaufruf:
      // setKioskFontSize('22');
    },
    getKioskFontSize() {
      const value = document.body.style.fontSize
      // const root = document.documentElement;
      // const styles = getComputedStyle(root);
      // const value = styles.getPropertyValue('--kiosk-font-size').trim();

      // Regex erklärt:
      // [^0-9.] matcht alles, was KEINE Ziffer und KEIN Punkt ist.
      // g (global) sorgt dafür, dass alle Buchstaben (rem, px, etc.) ersetzt werden.
      const size = value.replace(/[^0-9.]/g, '');
      this.kioskFontSize = parseFloat(size);
    },
    getAndroidJsonAppConfig() {
      ebus.$emit('getAndroidJsonAppConfig');
      setTimeout(() => {
        console.log('getAndroidJsonAppConfig  2/2: update UI ' + store.getters.androidJsonAppConfig);
        this.androidJsonAppConfig = '' + store.getters.androidJsonAppConfigString;
      }, 300);
    },
    setAndroidJsonAppConfig() {
      if (this.androidJsonAppConfig?.length) {
        ebus.$emit('setAndroidJsonAppConfig', '' + this.androidJsonAppConfig);
      }
    },

    // getSoftposStoreName() {
    //   ebus.$emit('getSoftposStoreName');
    //   setTimeout(() => {
    //     console.log('getSoftposStoreName  2/2: update UI ' + store.getters.softposStoreName);
    //     this.softposStoreName = '' + store.getters.softposStoreName;
    //   }, 300);
    // },
    // setSoftposStoreName() {
    //   if (this.softposStoreName?.length) {
    //     ebus.$emit('setSoftposStoreName', '' + this.softposStoreName);
    //   }
    // },

    getWindowsBluetoothDevices() {
      ebus.$emit('getWindowsBluetoothDevices');
      ebus.$emit('postToWindowskiosk', {
        action: 'getBluetoothDevices',
        cb: 'cb-postToWindowskiosk'
      });
      setTimeout(() => {
        console.log('getBluetoothDevices 2/2: update UI ' + store.getters.bluetoothDevices);
        this.bluetoothDevices = '' + store.getters.bluetoothDevices;
      }, 5000);
    },

    getAndroidBuildTime() {
      ebus.$emit('getAndroidBuildTime');
      setTimeout(() => {
        console.log('getAndroidBuildTime 2/2: update UI to bluetoothDevices ' + store.getters.androidBuildTime);
        this.androidBuildTime = '' + store.getters.androidBuildTime;
      }, 300);
    },

    getAndroidBluetoothDevices() {
      ebus.$emit('getAndroidBluetoothDevices');
      setTimeout(() => {
        console.log('getAndroidBluetoothDevices 2/2: update UI to bluetoothDevices ' + store.getters.bluetoothDevices);
        this.bluetoothDevices = '' + store.getters.bluetoothDevices;
      }, 300);
    },

    getAndroidAllPaymentStores() {
      ebus.$emit('getAndroidAllPaymentStores');
      setTimeout(() => {
        console.log('getAndroidAllPaymentStores 2/2: update UI to allPaymentStores ' + store.getters.bluetoothDevices);
        this.allPaymentStores = '' + store.getters.allPaymentStores;
      }, 2000);
    },

    getSoftposTerminalState() {
      ebus.$emit('getSoftposTerminalState');
    },

    getStorePicked() {
      ebus.$emit('getStorePicked');
    },

    getAndroidBonImageBase64(bonNumber) {
      ebus.$emit('getAndroidBonImageBase64', bonNumber);
    },

    getPrinterLog() {
      ebus.$emit('postToWindowskiosk', {
        action: 'getPrinterLog',
        cb: 'cb-postToWindowskiosk'
      });
      setTimeout(() => {
        console.log('getPrinterLog 2/2: update UI ' + store.getters.printerLog);
        this.printerLog = '' + store.getters.printerLog;
      }, 300);
    },

    getAndroidKioskUrl() {
      ebus.$emit('getKioskUrl');
      setTimeout(() => {
        console.log('getAndroidKioskUrl 2/2: update UI ' + store.getters.androidKioskUrl);
        this.androidKioskUrl = '' + store.getters.androidKioskUrl;
      }, 300);
    },
    setAndroidKioskUrl() {
      if (this.androidKioskUrl?.length) {
        ebus.$emit('saveKioskUrl', '' + this.androidKioskUrl);
      }
    },

    releaseTerminal() {
      ebus.$emit('releaseTerminal');
      ebus.$emit('showInfo', {
        title: 'Terminal Release wurde durchgeführt',
        // text: 'Vielen Dank!'
      });
    },

    dummyPrintKitchen() {
      if (store.getters.isAndroidKiosk) {
        ebus.$emit('postToWindowskiosk', {
          action: 'dummyPrintKitchen',
          cb: 'cb-androidDummyPrint'
        });
      } else {
        ebus.$emit('postToWindowskiosk', {
          action: 'dummyPrintKitchen',
          cb: 'cb-dummyPrint'
        });
      }
    },

    dummyPrint() {
      if (store.getters.isAndroidKiosk) {
        ebus.$emit('postToWindowskiosk', {
          action: 'dummyPrint',
          cb: 'cb-androidDummyPrint'
        });
      } else {
        ebus.$emit('postToWindowskiosk', {
          action: 'dummyPrint',
          cb: 'cb-dummyPrint'
        });
      }
    },

    clickSetupShowHide() {
      store.commit('hideSetupButton', !store.getters.hideSetupButton);
    },

    clickDebugParams() {
      ebus.$emit('goto', {name: 'debugParams'});
    },

    initIv() {
      if (this.iv1) {
        clearTheInterval(this.iv1);
      }

      this.iv1 = setInterval(() => {
        this.lastUpdateOutputParams = Date.now();
        this.readErgebnisFromTerminal();
      }, 15 * 1000);
    },

    validateDouble(value) {
      if (value === null || value === '') return true;
      return !isNaN(value) && !isNaN(parseFloat(value)) || 'Must be a valid number';
    },

    getCurrentTerminalIp() {
      ebus.$emit('postToWindowskiosk', {
        action: 'getCurrentTerminalIp',
        cb: 'cb-postToWindowskiosk'
      });
    },

    clickTriggerDiagnose() {
      ebus.$emit('postToWindowskiosk', {
        action: 'triggerDiagnose',
        cb: 'cb-postToWindowskiosk',
        timeout: 20 * 1000,
      });
    },

    readAllParams() {
      this.allParams = null;
      ebus.$emit('postToWindowskiosk', {
        action: 'readAllParams',
        cb: 'cb-postToWindowskiosk'
      });
    },

    readErgebnisFromTerminal() {
      ebus.$emit('postToWindowskiosk', {
        action: 'readErgebnisFromTerminal',
        //terminalId: '' + store.getters.table,
        cb: 'cb-postToWindowskiosk'
      });
    },

    triggerTerminalPayment() {
      console.log('testTriggerPosTerminal clicked');
      if (!store.getters.isKiosk) {
        return;
      }

      console.log('emit postToWindowskiosk');
      ebus.$emit('postToWindowskiosk', {
        action: 'triggerPosTerminal',
        uniqueOrderId: 'test-uniqueOrderId',
        betrag: 0 + this.doubleValue,
        trinkgeld: this.doubleTrinkgeld ? this.doubleTrinkgeld : 0,
        cb: 'cb-postToWindowskiosk'
      });

    },

    clickBestellungen() {
      setGlobalKeyValue('cashierAuth', true);
      this.$router.replace({name: 'Bestellungen'});
    },

    checkTerminalServiceActive() {
      console.log('checkTerminalServiceActive clicked');
      if (!store.getters.isKiosk) {
        return;
      }

      console.log('emit postToWindowskiosk');
      ebus.$emit('postToWindowskiosk', {
        action: 'checkTerminalServiceActive',
        cb: 'cb-postToWindowskiosk'
      });

    },

    finishSetup() {
      this.$router.replace({name: 'Home'});
    },

    exitApp() {
      ebus.$emit('doExitKiosk');
    },

    exitKiosk() {
      this.$ls.remove('kioskTable');
      store.commit('setIsKiosk', false);
      store.commit('setShowKioskSplashOnHome', false);
      store.commit('setEnableOrderModeSelection', false);
      store.commit('setEnableOrderModeSelectionWithTime', false);
      ebus.$emit('clearInhouseModus', {eventSource: 'exitKiosk'});
      this.$ls.remove('kioskTable');
      //   doReload('exitKiosk');

      //reload is required to load the default parameters again
      setTimeout(() => {
        doReload('exitKiosk');
      }, 500);

      this.$router.replace({name: 'Home'});
    },


  }
}
</script>

<style scoped lang="scss">
@import '../styles/base';

.configTable {
  width: 100%;

  td {
    padding: 2px 0;
  }

  td:first-child {
    width: 95%;
  }
}

.myBox {
  padding: 30px;
  margin: 20px;
  border: 2px solid black;;
  border-radius: $box-border-radius;
  background-color: white;
  overflow-x: hidden;
  max-width: 95vw;
  width: 100%;
}
</style>
